import { render, staticRenderFns } from "./LeaseSummaryTabScreen.vue?vue&type=template&id=af7130c2&"
import script from "./LeaseSummaryTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseSummaryTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af7130c2')) {
      api.createRecord('af7130c2', component.options)
    } else {
      api.reload('af7130c2', component.options)
    }
    module.hot.accept("./LeaseSummaryTabScreen.vue?vue&type=template&id=af7130c2&", function () {
      api.rerender('af7130c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeaseDetailsScreen/LeaseSummaryTabScreen.vue"
export default component.exports